import { InputAdornment, TextField, TextFieldProps } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { requiredMessage } from 'Regex';
import { UseFormRegisterReturn } from 'react-hook-form/dist/types';

export const PriceInput = (
  props: TextFieldProps & {
    label: string;
    register: UseFormRegisterReturn<string>;
    errors?: { message: string };
    shrink: boolean;
  }
) => {
  const isDesktop = useIsDesktop();

  return (
    <TextField
      type='number'
      label={props.label}
      error={props.errors?.message !== undefined}
      helperText={props.errors?.message}
      variant='outlined'
      sx={{
        width: isDesktop ? '400px' : '100%',
        borderRadius: '6px',
        '& .MuiOutlinedInput-notchedOutline': {
          borderRadius: '6px',
          border: '1px solid rgba(23, 82, 175, 0.2)',
          borderWidth: '1px !important',
          borderColor: 'primary.shade_200',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderRadius: '6px',
          border: '1px solid rgba(23, 82, 175, 0.2)',
          borderWidth: '1px !important',
          borderColor: 'primary.shade_200',
        },
        '& .MuiInputLabel-root[data-shrink="false"]': {
          mt: isDesktop ? '-5px' : '-8px',
        },
        '& .MuiTypography-root': { fontWeight: '400' },
        '.MuiInputBase-inputAdornedEnd': {
          textAlign: 'right',
        },
        ...props.sx,
      }}
      {...props.register}
      InputProps={{
        endAdornment: <InputAdornment position='end'>₪</InputAdornment>,
        inputMode: 'decimal',
        style: {
          padding: '0 14px',
          height: isDesktop ? '48px' : '42px',
        },
        'aria-required': props.errors?.message === requiredMessage,
      }}
      InputLabelProps={{ shrink: props.shrink }}
    />
  );
};
